export const HttpStatus = {
    "SUCCESS": 200,
    'UNAUTHORIZED': 401,
    "EXCEPTION": 417,
    "EXCEPTION406": 406,
    'LIMIT': 555,
};

export const COMMON_HAVE_NOTHING = {
    List: [
        { value: "01", label: "COMMON_FIELD_HAVE" },
        { value: "02", label: "COMMON_FIELD_NOTHING" },
    ],
    Map: {
        "01": "COMMON_FIELD_HAVE",
        "02": "COMMON_FIELD_NOTHING",
    },
    Enum: {
        Have: "01",
        Nothing: "02",
    }
};



export const AvailabilityTypes = {
    1: '有效',
    2: '无效',
}

export const SexTypes = {
    1: '男性',
    2: '女性',
}

export const RoleTypes = {
    1: '超级管理员',
    2: '普通管理员',
}

// 访问WebService的返回值定义
export const ReturnCodes = {
    'SUCCESS': 200,
    'UNAUTHORIZED': '401',
    'NOT_ACCEPTABLE': '406',
    'EXPECTATION_FAILED': '417'
}